[
  {
    "label": "GMT-11 - Pacific/Midway",
    "value": "Pacific/Midway"
  },
  {
    "label": "GMT-11 - Pacific/Niue - Alofi",
    "value": "Pacific/Niue"
  },
  {
    "label": "GMT-11 - Pacific/Pago_Pago - Pago Pago, Tāfuna, Ta`ū, Taulaga",
    "value": "Pacific/Pago_Pago"
  },
  {
    "label": "GMT-10 - America/Adak",
    "value": "America/Adak"
  },
  {
    "label": "GMT-10 - Pacific/Honolulu - Honolulu, East Honolulu, Pearl City, Hilo, Kailua",
    "value": "Pacific/Honolulu"
  },
  {
    "label": "GMT-10 - Pacific/Rarotonga - Avarua",
    "value": "Pacific/Rarotonga"
  },
  {
    "label": "GMT-10 - Pacific/Tahiti - Faaa, Papeete, Punaauia, Pirae, Mahina",
    "value": "Pacific/Tahiti"
  },
  {
    "label": "GMT-9:30 - Pacific/Marquesas - Taiohae",
    "value": "Pacific/Marquesas"
  },
  {
    "label": "GMT-9 - America/Anchorage - Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
    "value": "America/Anchorage"
  },
  {
    "label": "GMT-9 - America/Juneau - Juneau",
    "value": "America/Juneau"
  },
  {
    "label": "GMT-9 - America/Metlakatla",
    "value": "America/Metlakatla"
  },
  {
    "label": "GMT-9 - America/Nome",
    "value": "America/Nome"
  },
  {
    "label": "GMT-9 - America/Sitka - Sitka, Ketchikan",
    "value": "America/Sitka"
  },
  {
    "label": "GMT-9 - America/Yakutat",
    "value": "America/Yakutat"
  },
  {
    "label": "GMT-9 - Pacific/Gambier",
    "value": "Pacific/Gambier"
  },
  {
    "label": "GMT-8 - America/Los_Angeles - Los Angeles, San Diego, San Jose, San Francisco, Seattle",
    "value": "America/Los_Angeles"
  },
  {
    "label": "GMT-8 - America/Tijuana - Tijuana, Mexicali, Ensenada, Rosarito, Tecate",
    "value": "America/Tijuana"
  },
  {
    "label": "GMT-8 - America/Vancouver - Vancouver, Surrey, Okanagan, Victoria, Burnaby",
    "value": "America/Vancouver"
  },
  {
    "label": "GMT-8 - Pacific/Pitcairn - Adamstown",
    "value": "Pacific/Pitcairn"
  },
  {
    "label": "GMT-7 - America/Boise - Boise, Meridian, Nampa, Idaho Falls, Pocatello",
    "value": "America/Boise"
  },
  {
    "label": "GMT-7 - America/Cambridge_Bay",
    "value": "America/Cambridge_Bay"
  },
  {
    "label": "GMT-7 - America/Ciudad_Juarez - Ciudad Juárez, Ascensión, Ascención, Puerto Palomas",
    "value": "America/Ciudad_Juarez"
  },
  {
    "label": "GMT-7 - America/Creston - Creston",
    "value": "America/Creston"
  },
  {
    "label": "GMT-7 - America/Dawson",
    "value": "America/Dawson"
  },
  {
    "label": "GMT-7 - America/Dawson_Creek - Fort St. John, Dawson Creek",
    "value": "America/Dawson_Creek"
  },
  {
    "label": "GMT-7 - America/Denver - Denver, El Paso, Albuquerque, Colorado Springs, Aurora",
    "value": "America/Denver"
  },
  {
    "label": "GMT-7 - America/Edmonton - Calgary, Edmonton, Shaughnessy, Red Deer, Sherwood Park",
    "value": "America/Edmonton"
  },
  {
    "label": "GMT-7 - America/Fort_Nelson",
    "value": "America/Fort_Nelson"
  },
  {
    "label": "GMT-7 - America/Hermosillo - Hermosillo, Ciudad Obregón, Nogales, San Luis Río Colorado, Navojoa",
    "value": "America/Hermosillo"
  },
  {
    "label": "GMT-7 - America/Inuvik",
    "value": "America/Inuvik"
  },
  {
    "label": "GMT-7 - America/Mazatlan - Culiacán, Mazatlán, Tepic, Los Mochis, La Paz",
    "value": "America/Mazatlan"
  },
  {
    "label": "GMT-7 - America/Phoenix - Phoenix, Tucson, Mesa, Chandler, Gilbert",
    "value": "America/Phoenix"
  },
  {
    "label": "GMT-7 - America/Whitehorse - Whitehorse",
    "value": "America/Whitehorse"
  },
  {
    "label": "GMT-7 - America/Yellowknife - Yellowknife",
    "value": "America/Yellowknife"
  },
  {
    "label": "GMT-6 - America/Bahia_Banderas - Mezcales, San Vicente, Bucerías, Valle de Banderas",
    "value": "America/Bahia_Banderas"
  },
  {
    "label": "GMT-6 - America/Belize - Belize City, San Ignacio, San Pedro, Orange Walk, Corozal",
    "value": "America/Belize"
  },
  {
    "label": "GMT-6 - America/Chicago - Chicago, Houston, San Antonio, Dallas, Austin",
    "value": "America/Chicago"
  },
  {
    "label": "GMT-6 - America/Chihuahua - Chihuahua, Ciudad Delicias, Cuauhtémoc, Parral, Nuevo Casas Grandes",
    "value": "America/Chihuahua"
  },
  {
    "label": "GMT-6 - America/Costa_Rica - San José, Limón, San Francisco, Alajuela, Liberia",
    "value": "America/Costa_Rica"
  },
  {
    "label": "GMT-6 - America/El_Salvador - San Salvador, Soyapango, San Miguel, Santa Ana, Mejicanos",
    "value": "America/El_Salvador"
  },
  {
    "label": "GMT-6 - America/Guatemala - Guatemala City, Villa Nueva, Mixco, Cobán, Quetzaltenango",
    "value": "America/Guatemala"
  },
  {
    "label": "GMT-6 - America/Indiana/Knox",
    "value": "America/Indiana/Knox"
  },
  {
    "label": "GMT-6 - America/Indiana/Tell_City - Tell City",
    "value": "America/Indiana/Tell_City"
  },
  {
    "label": "GMT-6 - America/Managua - Managua, León, Masaya, Chinandega, Matagalpa",
    "value": "America/Managua"
  },
  {
    "label": "GMT-6 - America/Matamoros - Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras, Ciudad Acuña",
    "value": "America/Matamoros"
  },
  {
    "label": "GMT-6 - America/Menominee - Menominee, Iron Mountain, Kingsford, Ironwood",
    "value": "America/Menominee"
  },
  {
    "label": "GMT-6 - America/Merida - Mérida, Campeche, Ciudad del Carmen, Kanasín, Valladolid",
    "value": "America/Merida"
  },
  {
    "label": "GMT-6 - America/Mexico_City - Mexico City, Iztapalapa, León de los Aldama, Puebla, Ecatepec de Morelos",
    "value": "America/Mexico_City"
  },
  {
    "label": "GMT-6 - America/Monterrey - Monterrey, Torreón, Saltillo, Guadalupe, Victoria de Durango",
    "value": "America/Monterrey"
  },
  {
    "label": "GMT-6 - America/North_Dakota/Beulah",
    "value": "America/North_Dakota/Beulah"
  },
  {
    "label": "GMT-6 - America/North_Dakota/Center",
    "value": "America/North_Dakota/Center"
  },
  {
    "label": "GMT-6 - America/North_Dakota/New_Salem - Mandan",
    "value": "America/North_Dakota/New_Salem"
  },
  {
    "label": "GMT-6 - America/Ojinaga - Manuel Ojinaga, Ojinaga",
    "value": "America/Ojinaga"
  },
  {
    "label": "GMT-6 - America/Rankin_Inlet",
    "value": "America/Rankin_Inlet"
  },
  {
    "label": "GMT-6 - America/Regina - Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford",
    "value": "America/Regina"
  },
  {
    "label": "GMT-6 - America/Resolute",
    "value": "America/Resolute"
  },
  {
    "label": "GMT-6 - America/Swift_Current - Swift Current",
    "value": "America/Swift_Current"
  },
  {
    "label": "GMT-6 - America/Tegucigalpa - Tegucigalpa, San Pedro Sula, La Ceiba, Choloma, El Progreso",
    "value": "America/Tegucigalpa"
  },
  {
    "label": "GMT-6 - America/Winnipeg - Winnipeg, Brandon, Steinbach, Kenora, Thompson",
    "value": "America/Winnipeg"
  },
  {
    "label": "GMT-6 - Pacific/Easter - Hanga Roa",
    "value": "Pacific/Easter"
  },
  {
    "label": "GMT-6 - Pacific/Galapagos - Puerto Ayora, Puerto Baquerizo Moreno",
    "value": "Pacific/Galapagos"
  },
  {
    "label": "GMT-5 - America/Atikokan",
    "value": "America/Atikokan"
  },
  {
    "label": "GMT-5 - America/Bogota - Bogotá, Cali, Medellín, Barranquilla, Cartagena",
    "value": "America/Bogota"
  },
  {
    "label": "GMT-5 - America/Cancun - Cancún, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto",
    "value": "America/Cancun"
  },
  {
    "label": "GMT-5 - America/Cayman - George Town, West Bay, Bodden Town, North Side, East End",
    "value": "America/Cayman"
  },
  {
    "label": "GMT-5 - America/Detroit - Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor",
    "value": "America/Detroit"
  },
  {
    "label": "GMT-5 - America/Eirunepe - Eirunepé, Benjamin Constant, Envira",
    "value": "America/Eirunepe"
  },
  {
    "label": "GMT-5 - America/Grand_Turk - Cockburn Town",
    "value": "America/Grand_Turk"
  },
  {
    "label": "GMT-5 - America/Guayaquil - Quito, Guayaquil, Cuenca, Santo Domingo de los Colorados, Ambato",
    "value": "America/Guayaquil"
  },
  {
    "label": "GMT-5 - America/Havana - Havana, Santiago de Cuba, Camagüey, Holguín, Guantánamo",
    "value": "America/Havana"
  },
  {
    "label": "GMT-5 - America/Indiana/Indianapolis - Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington",
    "value": "America/Indiana/Indianapolis"
  },
  {
    "label": "GMT-5 - America/Indiana/Marengo",
    "value": "America/Indiana/Marengo"
  },
  {
    "label": "GMT-5 - America/Indiana/Petersburg",
    "value": "America/Indiana/Petersburg"
  },
  {
    "label": "GMT-5 - America/Indiana/Vevay",
    "value": "America/Indiana/Vevay"
  },
  {
    "label": "GMT-5 - America/Indiana/Vincennes - Jasper, Washington, Huntingburg",
    "value": "America/Indiana/Vincennes"
  },
  {
    "label": "GMT-5 - America/Indiana/Winamac",
    "value": "America/Indiana/Winamac"
  },
  {
    "label": "GMT-5 - America/Iqaluit - Iqaluit",
    "value": "America/Iqaluit"
  },
  {
    "label": "GMT-5 - America/Jamaica - Kingston, New Kingston, Spanish Town, Portmore, Montego Bay",
    "value": "America/Jamaica"
  },
  {
    "label": "GMT-5 - America/Kentucky/Louisville - Louisville, Jeffersonville, New Albany, Jeffersontown, Pleasure Ridge Park",
    "value": "America/Kentucky/Louisville"
  },
  {
    "label": "GMT-5 - America/Kentucky/Monticello - Monticello",
    "value": "America/Kentucky/Monticello"
  },
  {
    "label": "GMT-5 - America/Lima - Lima, Callao, Arequipa, Trujillo, Chiclayo",
    "value": "America/Lima"
  },
  {
    "label": "GMT-5 - America/Nassau - Nassau, Lucaya, Freeport, West End, Cooper’s Town",
    "value": "America/Nassau"
  },
  {
    "label": "GMT-5 - America/New_York - New York City, Brooklyn, Queens, Philadelphia, Manhattan",
    "value": "America/New_York"
  },
  {
    "label": "GMT-5 - America/Panama - Panamá, San Miguelito, Juan Díaz, David, Arraiján",
    "value": "America/Panama"
  },
  {
    "label": "GMT-5 - America/Port-au-Prince - Port-au-Prince, Carrefour, Delmas 73, Port-de-Paix, Pétionville",
    "value": "America/Port-au-Prince"
  },
  {
    "label": "GMT-5 - America/Rio_Branco - Rio Branco, Cruzeiro do Sul, Senador Guiomard, Sena Madureira, Tarauacá",
    "value": "America/Rio_Branco"
  },
  {
    "label": "GMT-5 - America/Toronto - Toronto, Montréal, Ottawa, Mississauga, Brampton",
    "value": "America/Toronto"
  },
  {
    "label": "GMT-4 - America/Anguilla - The Valley, Blowing Point Village, Sandy Ground Village, The Quarter, Sandy Hill",
    "value": "America/Anguilla"
  },
  {
    "label": "GMT-4 - America/Antigua - Saint John’s, Piggotts, Bolands, Codrington, Parham",
    "value": "America/Antigua"
  },
  {
    "label": "GMT-4 - America/Aruba - Oranjestad, Tanki Leendert, San Nicolas, Santa Cruz, Paradera",
    "value": "America/Aruba"
  },
  {
    "label": "GMT-4 - America/Asuncion - Asunción, Ciudad del Este, San Lorenzo, Capiatá, Lambaré",
    "value": "America/Asuncion"
  },
  {
    "label": "GMT-4 - America/Barbados - Bridgetown, Speightstown, Oistins, Bathsheba, Holetown",
    "value": "America/Barbados"
  },
  {
    "label": "GMT-4 - America/Blanc-Sablon",
    "value": "America/Blanc-Sablon"
  },
  {
    "label": "GMT-4 - America/Boa_Vista - Boa Vista",
    "value": "America/Boa_Vista"
  },
  {
    "label": "GMT-4 - America/Campo_Grande - Campo Grande, Dourados, Corumbá, Três Lagoas, Ponta Porã",
    "value": "America/Campo_Grande"
  },
  {
    "label": "GMT-4 - America/Caracas - Caracas, Maracaibo, Maracay, Valencia, Barquisimeto",
    "value": "America/Caracas"
  },
  {
    "label": "GMT-4 - America/Cuiaba - Cuiabá, Várzea Grande, Rondonópolis, Sinop, Barra do Garças",
    "value": "America/Cuiaba"
  },
  {
    "label": "GMT-4 - America/Curacao - Willemstad, Sint Michiel Liber",
    "value": "America/Curacao"
  },
  {
    "label": "GMT-4 - America/Dominica - Roseau, Portsmouth, Berekua, Saint Joseph, Wesley",
    "value": "America/Dominica"
  },
  {
    "label": "GMT-4 - America/Glace_Bay - Sydney, Glace Bay, Sydney Mines",
    "value": "America/Glace_Bay"
  },
  {
    "label": "GMT-4 - America/Goose_Bay - Happy Valley-Goose Bay, Labrador City",
    "value": "America/Goose_Bay"
  },
  {
    "label": "GMT-4 - America/Grenada - Saint George's, Gouyave, Grenville, Victoria, Saint David’s",
    "value": "America/Grenada"
  },
  {
    "label": "GMT-4 - America/Guadeloupe - Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg, Sainte-Anne",
    "value": "America/Guadeloupe"
  },
  {
    "label": "GMT-4 - America/Guyana - Georgetown, Linden, New Amsterdam, Anna Regina, Bartica",
    "value": "America/Guyana"
  },
  {
    "label": "GMT-4 - America/Halifax - Halifax, Dartmouth, Charlottetown, Lower Sackville, Cole Harbour",
    "value": "America/Halifax"
  },
  {
    "label": "GMT-4 - America/Kralendijk - Kralendijk, Oranjestad, The Bottom",
    "value": "America/Kralendijk"
  },
  {
    "label": "GMT-4 - America/La_Paz - La Paz, Santa Cruz de la Sierra, Cochabamba, Sucre, Oruro",
    "value": "America/La_Paz"
  },
  {
    "label": "GMT-4 - America/Lower_Princes - Cul de Sac, Lower Prince’s Quarter, Koolbaai, Philipsburg",
    "value": "America/Lower_Princes"
  },
  {
    "label": "GMT-4 - America/Manaus - Manaus, Itacoatiara, Parintins, Manacapuru, Coari",
    "value": "America/Manaus"
  },
  {
    "label": "GMT-4 - America/Marigot - Marigot",
    "value": "America/Marigot"
  },
  {
    "label": "GMT-4 - America/Martinique - Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie, Le François",
    "value": "America/Martinique"
  },
  {
    "label": "GMT-4 - America/Moncton - Moncton, Saint John, Fredericton, Dieppe, Miramichi",
    "value": "America/Moncton"
  },
  {
    "label": "GMT-4 - America/Montserrat - Brades, Saint Peters, Plymouth",
    "value": "America/Montserrat"
  },
  {
    "label": "GMT-4 - America/Porto_Velho - Porto Velho, Ji Paraná, Vilhena, Ariquemes, Cacoal",
    "value": "America/Porto_Velho"
  },
  {
    "label": "GMT-4 - America/Port_of_Spain - Chaguanas, Mon Repos, San Fernando, Port of Spain, Rio Claro",
    "value": "America/Port_of_Spain"
  },
  {
    "label": "GMT-4 - America/Puerto_Rico - San Juan, Bayamón, Carolina, Ponce, Arecibo",
    "value": "America/Puerto_Rico"
  },
  {
    "label": "GMT-4 - America/Santiago - Santiago, Puente Alto, Antofagasta, Viña del Mar, Valparaíso",
    "value": "America/Santiago"
  },
  {
    "label": "GMT-4 - America/Santo_Domingo - Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este, San Pedro de Macorís",
    "value": "America/Santo_Domingo"
  },
  {
    "label": "GMT-4 - America/St_Barthelemy - Gustavia",
    "value": "America/St_Barthelemy"
  },
  {
    "label": "GMT-4 - America/St_Kitts - Basseterre, Fig Tree, Market Shop, Saint Paul’s, Middle Island",
    "value": "America/St_Kitts"
  },
  {
    "label": "GMT-4 - America/St_Lucia - Castries, Bisee, Vieux Fort, Micoud, Soufrière",
    "value": "America/St_Lucia"
  },
  {
    "label": "GMT-4 - America/St_Thomas - Saint Croix, Charlotte Amalie, Cruz Bay",
    "value": "America/St_Thomas"
  },
  {
    "label": "GMT-4 - America/St_Vincent - Kingstown, Georgetown, Barrouallie, Port Elizabeth, Chateaubelair",
    "value": "America/St_Vincent"
  },
  {
    "label": "GMT-4 - America/Thule",
    "value": "America/Thule"
  },
  {
    "label": "GMT-4 - America/Tortola - Road Town",
    "value": "America/Tortola"
  },
  {
    "label": "GMT-4 - Atlantic/Bermuda - Hamilton",
    "value": "Atlantic/Bermuda"
  },
  {
    "label": "GMT-3:30 - America/St_Johns - St. John's, Mount Pearl, Corner Brook, Conception Bay South, Grand Falls-Windsor",
    "value": "America/St_Johns"
  },
  {
    "label": "GMT-3 - America/Araguaina - Palmas, Araguaína, Gurupi, Miracema do Tocantins, Taguatinga",
    "value": "America/Araguaina"
  },
  {
    "label": "GMT-3 - America/Argentina/Buenos_Aires - Buenos Aires, Mar del Plata, Bahía Blanca, Merlo, Quilmes",
    "value": "America/Argentina/Buenos_Aires"
  },
  {
    "label": "GMT-3 - America/Argentina/Catamarca - Catamarca, Comodoro Rivadavia, Trelew, Puerto Madryn, Esquel",
    "value": "America/Argentina/Catamarca"
  },
  {
    "label": "GMT-3 - America/Argentina/Cordoba - Córdoba, Rosario, Santa Fe, Corrientes, Posadas",
    "value": "America/Argentina/Cordoba"
  },
  {
    "label": "GMT-3 - America/Argentina/Jujuy - San Salvador de Jujuy, San Pedro de Jujuy, Libertador General San Martín, Palpalá, La Quiaca",
    "value": "America/Argentina/Jujuy"
  },
  {
    "label": "GMT-3 - America/Argentina/La_Rioja - La Rioja, Chilecito, Arauco, Chamical",
    "value": "America/Argentina/La_Rioja"
  },
  {
    "label": "GMT-3 - America/Argentina/Mendoza - San Rafael, Mendoza, San Martín",
    "value": "America/Argentina/Mendoza"
  },
  {
    "label": "GMT-3 - America/Argentina/Rio_Gallegos - Río Gallegos, Caleta Olivia, Pico Truncado, Puerto Deseado, Las Heras",
    "value": "America/Argentina/Rio_Gallegos"
  },
  {
    "label": "GMT-3 - America/Argentina/Salta - Salta, Neuquén, Santa Rosa, San Carlos de Bariloche, Cipolletti",
    "value": "America/Argentina/Salta"
  },
  {
    "label": "GMT-3 - America/Argentina/San_Juan - San Juan, Chimbas, Santa Lucía, Pocito, Caucete",
    "value": "America/Argentina/San_Juan"
  },
  {
    "label": "GMT-3 - America/Argentina/San_Luis - San Luis, Villa Mercedes, La Punta, Merlo, Justo Daract",
    "value": "America/Argentina/San_Luis"
  },
  {
    "label": "GMT-3 - America/Argentina/Tucuman - San Miguel de Tucumán, Yerba Buena, Tafí Viejo, Alderetes, Aguilares",
    "value": "America/Argentina/Tucuman"
  },
  {
    "label": "GMT-3 - America/Argentina/Ushuaia - Ushuaia, Río Grande",
    "value": "America/Argentina/Ushuaia"
  },
  {
    "label": "GMT-3 - America/Bahia - Salvador, Feira de Santana, Vitória da Conquista, Itabuna, Camaçari",
    "value": "America/Bahia"
  },
  {
    "label": "GMT-3 - America/Belem - Belém, Macapá, Ananindeua, Parauapebas, Marabá",
    "value": "America/Belem"
  },
  {
    "label": "GMT-3 - America/Cayenne - Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou, Rémire-Montjoly",
    "value": "America/Cayenne"
  },
  {
    "label": "GMT-3 - America/Fortaleza - Fortaleza, São Luís, Natal, Teresina, João Pessoa",
    "value": "America/Fortaleza"
  },
  {
    "label": "GMT-3 - America/Maceio - Maceió, Aracaju, Arapiraca, Nossa Senhora do Socorro, São Cristóvão",
    "value": "America/Maceio"
  },
  {
    "label": "GMT-3 - America/Miquelon - Saint-Pierre, Miquelon",
    "value": "America/Miquelon"
  },
  {
    "label": "GMT-3 - America/Montevideo - Montevideo, Salto, Paysandú, Las Piedras, Rivera",
    "value": "America/Montevideo"
  },
  {
    "label": "GMT-3 - America/Paramaribo - Paramaribo, Lelydorp, Brokopondo, Nieuw Nickerie, Meerzorg",
    "value": "America/Paramaribo"
  },
  {
    "label": "GMT-3 - America/Punta_Arenas - Punta Arenas, Puerto Natales",
    "value": "America/Punta_Arenas"
  },
  {
    "label": "GMT-3 - America/Recife - Recife, Jaboatão, Jaboatão dos Guararapes, Olinda, Paulista",
    "value": "America/Recife"
  },
  {
    "label": "GMT-3 - America/Santarem - Santarém, Altamira, Itaituba, Óbidos, Oriximiná",
    "value": "America/Santarem"
  },
  {
    "label": "GMT-3 - America/Sao_Paulo - São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Curitiba",
    "value": "America/Sao_Paulo"
  },
  {
    "label": "GMT-3 - Antarctica/Palmer",
    "value": "Antarctica/Palmer"
  },
  {
    "label": "GMT-3 - Antarctica/Rothera",
    "value": "Antarctica/Rothera"
  },
  {
    "label": "GMT-3 - Atlantic/Stanley - Stanley",
    "value": "Atlantic/Stanley"
  },
  {
    "label": "GMT-2 - America/Noronha",
    "value": "America/Noronha"
  },
  {
    "label": "GMT-2 - America/Nuuk - Nuuk, Sisimiut, Ilulissat, Qaqortoq, Aasiaat",
    "value": "America/Nuuk"
  },
  {
    "label": "GMT-2 - Atlantic/South_Georgia - Grytviken",
    "value": "Atlantic/South_Georgia"
  },
  {
    "label": "GMT-1 - America/Scoresbysund",
    "value": "America/Scoresbysund"
  },
  {
    "label": "GMT-1 - Atlantic/Azores - Ponta Delgada, Lagoa, Angra do Heroísmo, Rosto de Cão, Rabo de Peixe",
    "value": "Atlantic/Azores"
  },
  {
    "label": "GMT-1 - Atlantic/Cape_Verde - Praia, Mindelo, Espargos, Assomada, Tarrafal",
    "value": "Atlantic/Cape_Verde"
  },
  {
    "label": "GMT+0 - Africa/Abidjan - Abidjan, Abobo, Bouaké, Korhogo, Daloa",
    "value": "Africa/Abidjan"
  },
  {
    "label": "GMT+0 - Africa/Accra - Kumasi, Accra, Tamale, Takoradi, Sekondi",
    "value": "Africa/Accra"
  },
  {
    "label": "GMT+0 - Africa/Bamako - Bamako, Ségou, Sikasso, Mopti, Koutiala",
    "value": "Africa/Bamako"
  },
  {
    "label": "GMT+0 - Africa/Banjul - Serekunda, Brikama, Bununka Kunda, Sukuta, Talinding",
    "value": "Africa/Banjul"
  },
  {
    "label": "GMT+0 - Africa/Bissau - Bissau, Gabú, Bafatá, Canchungo, Bissorã",
    "value": "Africa/Bissau"
  },
  {
    "label": "GMT+0 - Africa/Casablanca - Casablanca, Rabat, Fès, Sale, Marrakesh",
    "value": "Africa/Casablanca"
  },
  {
    "label": "GMT+0 - Africa/Conakry - Conakry, Camayenne, Nzérékoré, Kankan, Manéah",
    "value": "Africa/Conakry"
  },
  {
    "label": "GMT+0 - Africa/Dakar - Dakar, Pikine, Touba, Thiès, Thiès Nones",
    "value": "Africa/Dakar"
  },
  {
    "label": "GMT+0 - Africa/El_Aaiun - Laayoune, Dakhla, Boujdour, Laayoune Plage",
    "value": "Africa/El_Aaiun"
  },
  {
    "label": "GMT+0 - Africa/Freetown - Freetown, Bo, Kenema, Koidu, Makeni",
    "value": "Africa/Freetown"
  },
  {
    "label": "GMT+0 - Africa/Lome - Lomé, Sokodé, Kara, Atakpamé, Kpalimé",
    "value": "Africa/Lome"
  },
  {
    "label": "GMT+0 - Africa/Monrovia - Monrovia, Gbarnga, Buchanan, Kakata, Zwedru",
    "value": "Africa/Monrovia"
  },
  {
    "label": "GMT+0 - Africa/Nouakchott - Nouakchott, Nouadhibou, Dar Naim, Néma, Kaédi",
    "value": "Africa/Nouakchott"
  },
  {
    "label": "GMT+0 - Africa/Ouagadougou - Ouagadougou, Bobo-Dioulasso, Koudougou, Saaba, Ouahigouya",
    "value": "Africa/Ouagadougou"
  },
  {
    "label": "GMT+0 - Africa/Sao_Tome - São Tomé, Santo António",
    "value": "Africa/Sao_Tome"
  },
  {
    "label": "GMT+0 - America/Danmarkshavn",
    "value": "America/Danmarkshavn"
  },
  {
    "label": "GMT+0 - Antarctica/Troll",
    "value": "Antarctica/Troll"
  },
  {
    "label": "GMT+0 - Atlantic/Canary - Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde, Arona",
    "value": "Atlantic/Canary"
  },
  {
    "label": "GMT+0 - Atlantic/Faroe - Tórshavn, Klaksvík, Fuglafjørður, Miðvágur, Tvøroyri",
    "value": "Atlantic/Faroe"
  },
  {
    "label": "GMT+0 - Atlantic/Madeira - Funchal, Câmara de Lobos, São Martinho, Caniço, Machico",
    "value": "Atlantic/Madeira"
  },
  {
    "label": "GMT+0 - Atlantic/Reykjavik - Reykjavík, Kópavogur, Hafnarfjörður, Reykjanesbær, Akureyri",
    "value": "Atlantic/Reykjavik"
  },
  {
    "label": "GMT+0 - Atlantic/St_Helena - Jamestown, Georgetown, Edinburgh of the Seven Seas",
    "value": "Atlantic/St_Helena"
  },
  {
    "label": "GMT+0 - Europe/Dublin - Dublin, South Dublin, Cork, Limerick, Galway",
    "value": "Europe/Dublin"
  },
  {
    "label": "GMT+0 - Europe/Guernsey - Saint Peter Port, Saint Sampson, St Martin, St Anne, Saint Saviour",
    "value": "Europe/Guernsey"
  },
  {
    "label": "GMT+0 - Europe/Isle_of_Man - Douglas, Ramsey, Peel, Port Erin, Castletown",
    "value": "Europe/Isle_of_Man"
  },
  {
    "label": "GMT+0 - Europe/Jersey - Saint Helier, Le Hocq",
    "value": "Europe/Jersey"
  },
  {
    "label": "GMT+0 - Europe/Lisbon - Lisbon, Porto, Amadora, Braga, Setúbal",
    "value": "Europe/Lisbon"
  },
  {
    "label": "GMT+0 - Europe/London - London, Birmingham, Liverpool, Glasgow, Sheffield",
    "value": "Europe/London"
  },
  {
    "label": "GMT+1 - Africa/Algiers - Algiers, Oran, Constantine, Annaba, Blida",
    "value": "Africa/Algiers"
  },
  {
    "label": "GMT+1 - Africa/Bangui - Bangui, Bimbo, Bégoua, Carnot, Berbérati",
    "value": "Africa/Bangui"
  },
  {
    "label": "GMT+1 - Africa/Brazzaville - Brazzaville, Pointe-Noire, Dolisie, Nkayi, Kayes",
    "value": "Africa/Brazzaville"
  },
  {
    "label": "GMT+1 - Africa/Ceuta - Melilla",
    "value": "Africa/Ceuta"
  },
  {
    "label": "GMT+1 - Africa/Douala - Douala, Yaoundé, Bamenda, Bafoussam, Maroua",
    "value": "Africa/Douala"
  },
  {
    "label": "GMT+1 - Africa/Kinshasa - Kinshasa, Kikwit, Masina, Mbandaka, Matadi",
    "value": "Africa/Kinshasa"
  },
  {
    "label": "GMT+1 - Africa/Lagos - Lagos, Kano, Ibadan, Port Harcourt, Benin City",
    "value": "Africa/Lagos"
  },
  {
    "label": "GMT+1 - Africa/Libreville - Libreville, Port-Gentil, Franceville, Owendo, Oyem",
    "value": "Africa/Libreville"
  },
  {
    "label": "GMT+1 - Africa/Luanda - Luanda, Lubango, Huambo, Benguela, Cabinda",
    "value": "Africa/Luanda"
  },
  {
    "label": "GMT+1 - Africa/Malabo - Bata, Malabo, Ebebiyin, Aconibe, Añisoc",
    "value": "Africa/Malabo"
  },
  {
    "label": "GMT+1 - Africa/Ndjamena - N'Djamena, Moundou, Abéché, Sarh, Kelo",
    "value": "Africa/Ndjamena"
  },
  {
    "label": "GMT+1 - Africa/Niamey - Niamey, Zinder, Maradi, Agadez, Alaghsas",
    "value": "Africa/Niamey"
  },
  {
    "label": "GMT+1 - Africa/Porto-Novo - Cotonou, Abomey-Calavi, Porto-Novo, Parakou, Godomè",
    "value": "Africa/Porto-Novo"
  },
  {
    "label": "GMT+1 - Africa/Tunis - Tunis, Sfax, Sousse, Kairouan, Bizerte",
    "value": "Africa/Tunis"
  },
  {
    "label": "GMT+1 - Africa/Windhoek - Windhoek, Rundu, Walvis Bay, Oshakati, Swakopmund",
    "value": "Africa/Windhoek"
  },
  {
    "label": "GMT+1 - Arctic/Longyearbyen - Longyearbyen, Olonkinbyen",
    "value": "Arctic/Longyearbyen"
  },
  {
    "label": "GMT+1 - Europe/Amsterdam - Amsterdam, Rotterdam, The Hague, Utrecht, Groningen",
    "value": "Europe/Amsterdam"
  },
  {
    "label": "GMT+1 - Europe/Andorra - Andorra la Vella, les Escaldes, Encamp, Sant Julià de Lòria, la Massana",
    "value": "Europe/Andorra"
  },
  {
    "label": "GMT+1 - Europe/Belgrade - Belgrade, Pristina, Niš, Novi Sad, Prizren",
    "value": "Europe/Belgrade"
  },
  {
    "label": "GMT+1 - Europe/Berlin - Berlin, Hamburg, Munich, Köln, Frankfurt am Main",
    "value": "Europe/Berlin"
  },
  {
    "label": "GMT+1 - Europe/Bratislava - Bratislava, Košice, Nitra, Prešov, Žilina",
    "value": "Europe/Bratislava"
  },
  {
    "label": "GMT+1 - Europe/Brussels - Brussels, Antwerpen, Gent, Charleroi, Liège",
    "value": "Europe/Brussels"
  },
  {
    "label": "GMT+1 - Europe/Budapest - Budapest, Debrecen, Szeged, Miskolc, Pécs",
    "value": "Europe/Budapest"
  },
  {
    "label": "GMT+1 - Europe/Copenhagen - Copenhagen, Aarhus, Odense, Aalborg, Frederiksberg",
    "value": "Europe/Copenhagen"
  },
  {
    "label": "GMT+1 - Europe/Gibraltar - Gibraltar",
    "value": "Europe/Gibraltar"
  },
  {
    "label": "GMT+1 - Europe/Ljubljana - Ljubljana, Maribor, Kranj, Celje, Koper",
    "value": "Europe/Ljubljana"
  },
  {
    "label": "GMT+1 - Europe/Luxembourg - Luxembourg, Esch-sur-Alzette, Dudelange, Schifflange, Bettembourg",
    "value": "Europe/Luxembourg"
  },
  {
    "label": "GMT+1 - Europe/Madrid - Madrid, Barcelona, Valencia, Sevilla, Zaragoza",
    "value": "Europe/Madrid"
  },
  {
    "label": "GMT+1 - Europe/Malta - San Pawl il-Baħar, Birkirkara, Mosta, Sliema, Qormi",
    "value": "Europe/Malta"
  },
  {
    "label": "GMT+1 - Europe/Monaco - Monaco, Monte-Carlo, La Condamine",
    "value": "Europe/Monaco"
  },
  {
    "label": "GMT+1 - Europe/Oslo - Oslo, Bergen, Trondheim, Stavanger, Drammen",
    "value": "Europe/Oslo"
  },
  {
    "label": "GMT+1 - Europe/Paris - Paris, Marseille, Lyon, Toulouse, Nice",
    "value": "Europe/Paris"
  },
  {
    "label": "GMT+1 - Europe/Podgorica - Podgorica, Nikšić, Herceg Novi, Pljevlja, Budva",
    "value": "Europe/Podgorica"
  },
  {
    "label": "GMT+1 - Europe/Prague - Prague, Brno, Ostrava, Pilsen, Liberec",
    "value": "Europe/Prague"
  },
  {
    "label": "GMT+1 - Europe/Rome - Rome, Milan, Naples, Turin, Palermo",
    "value": "Europe/Rome"
  },
  {
    "label": "GMT+1 - Europe/San_Marino - Serravalle, Borgo Maggiore, San Marino, Domagnano, Fiorentino",
    "value": "Europe/San_Marino"
  },
  {
    "label": "GMT+1 - Europe/Sarajevo - Sarajevo, Banja Luka, Zenica, Tuzla, Mostar",
    "value": "Europe/Sarajevo"
  },
  {
    "label": "GMT+1 - Europe/Skopje - Skopje, Kumanovo, Prilep, Bitola, Čair",
    "value": "Europe/Skopje"
  },
  {
    "label": "GMT+1 - Europe/Stockholm - Stockholm, Göteborg, Malmö, Uppsala, Linköping",
    "value": "Europe/Stockholm"
  },
  {
    "label": "GMT+1 - Europe/Tirane - Tirana, Durrës, Elbasan, Vlorë, Shkodër",
    "value": "Europe/Tirane"
  },
  {
    "label": "GMT+1 - Europe/Vaduz - Schaan, Vaduz, Triesen, Balzers, Eschen",
    "value": "Europe/Vaduz"
  },
  {
    "label": "GMT+1 - Europe/Vatican - Vatican City",
    "value": "Europe/Vatican"
  },
  {
    "label": "GMT+1 - Europe/Vienna - Vienna, Graz, Linz, Favoriten, Donaustadt",
    "value": "Europe/Vienna"
  },
  {
    "label": "GMT+1 - Europe/Warsaw - Warsaw, Łódź, Kraków, Wrocław, Poznań",
    "value": "Europe/Warsaw"
  },
  {
    "label": "GMT+1 - Europe/Zagreb - Zagreb, Split, Rijeka, Osijek, Zadar",
    "value": "Europe/Zagreb"
  },
  {
    "label": "GMT+1 - Europe/Zurich - Zürich, Genève, Basel, Lausanne, Bern",
    "value": "Europe/Zurich"
  },
  {
    "label": "GMT+2 - Africa/Blantyre - Lilongwe, Blantyre, Mzuzu, Zomba, Kasungu",
    "value": "Africa/Blantyre"
  },
  {
    "label": "GMT+2 - Africa/Bujumbura - Bujumbura, Gitega, Ngozi, Rumonge, Cibitoke",
    "value": "Africa/Bujumbura"
  },
  {
    "label": "GMT+2 - Africa/Cairo - Cairo, Alexandria, Giza, Shubrā al Khaymah, Port Said",
    "value": "Africa/Cairo"
  },
  {
    "label": "GMT+2 - Africa/Gaborone - Gaborone, Francistown, Mogoditshane, Maun, Molepolole",
    "value": "Africa/Gaborone"
  },
  {
    "label": "GMT+2 - Africa/Harare - Harare, Bulawayo, Chitungwiza, Mutare, Gweru",
    "value": "Africa/Harare"
  },
  {
    "label": "GMT+2 - Africa/Johannesburg - Johannesburg, Cape Town, Durban, Soweto, Pretoria",
    "value": "Africa/Johannesburg"
  },
  {
    "label": "GMT+2 - Africa/Juba - Juba, Winejok, Yei, Malakal, Wau",
    "value": "Africa/Juba"
  },
  {
    "label": "GMT+2 - Africa/Khartoum - Khartoum, Omdurman, Nyala, Port Sudan, Kassala",
    "value": "Africa/Khartoum"
  },
  {
    "label": "GMT+2 - Africa/Kigali - Kigali, Gisenyi, Butare, Gitarama, Musanze",
    "value": "Africa/Kigali"
  },
  {
    "label": "GMT+2 - Africa/Lubumbashi - Lubumbashi, Mbuji-Mayi, Kananga, Kisangani, Bukavu",
    "value": "Africa/Lubumbashi"
  },
  {
    "label": "GMT+2 - Africa/Lusaka - Lusaka, Ndola, Kitwe, Chipata, Kabwe",
    "value": "Africa/Lusaka"
  },
  {
    "label": "GMT+2 - Africa/Maputo - Maputo, Matola, Nampula, Beira, Chimoio",
    "value": "Africa/Maputo"
  },
  {
    "label": "GMT+2 - Africa/Maseru - Maseru, Maputsoe, Mohale's Hoek, Mafeteng, Hlotse",
    "value": "Africa/Maseru"
  },
  {
    "label": "GMT+2 - Africa/Mbabane - Manzini, Mbabane, Big Bend, Malkerns, Nhlangano",
    "value": "Africa/Mbabane"
  },
  {
    "label": "GMT+2 - Africa/Tripoli - Tripoli, Benghazi, Misratah, Zliten, Al Khums",
    "value": "Africa/Tripoli"
  },
  {
    "label": "GMT+2 - Asia/Beirut - Beirut, Ra’s Bayrūt, Tripoli, Sidon, Tyre",
    "value": "Asia/Beirut"
  },
  {
    "label": "GMT+2 - Asia/Famagusta - Famagusta, Kyrenia, Égkomi, Protaras, Paralímni",
    "value": "Asia/Famagusta"
  },
  {
    "label": "GMT+2 - Asia/Gaza - Gaza, Khān Yūnis, Jabālyā, Rafaḩ, Dayr al Balaḩ",
    "value": "Asia/Gaza"
  },
  {
    "label": "GMT+2 - Asia/Hebron - East Jerusalem, Hebron, Nablus, Ţūlkarm, Qalqīlyah",
    "value": "Asia/Hebron"
  },
  {
    "label": "GMT+2 - Asia/Jerusalem - Jerusalem, Tel Aviv, West Jerusalem, Haifa, Rishon LeTsiyyon",
    "value": "Asia/Jerusalem"
  },
  {
    "label": "GMT+2 - Asia/Nicosia - Nicosia, Limassol, Larnaca, Stróvolos, Káto Lakatámeia",
    "value": "Asia/Nicosia"
  },
  {
    "label": "GMT+2 - Europe/Athens - Athens, Thessaloníki, Pátra, Piraeus, Lárisa",
    "value": "Europe/Athens"
  },
  {
    "label": "GMT+2 - Europe/Bucharest - Bucharest",
    "value": "Europe/Bucharest"
  },
  {
    "label": "GMT+2 - Europe/Chisinau - Chisinau, Tiraspol, Bălţi, Bender, Rîbniţa",
    "value": "Europe/Chisinau"
  },
  {
    "label": "GMT+2 - Europe/Helsinki - Helsinki, Espoo, Tampere, Oulu, Turku",
    "value": "Europe/Helsinki"
  },
  {
    "label": "GMT+2 - Europe/Kaliningrad - Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk, Gusev",
    "value": "Europe/Kaliningrad"
  },
  {
    "label": "GMT+2 - Europe/Kyiv - Kyiv, Kharkiv, Odesa, Dnipro, Donetsk",
    "value": "Europe/Kyiv"
  },
  {
    "label": "GMT+2 - Europe/Mariehamn - Mariehamn",
    "value": "Europe/Mariehamn"
  },
  {
    "label": "GMT+2 - Europe/Riga - Riga, Daugavpils, Liepāja, Jelgava, Jūrmala",
    "value": "Europe/Riga"
  },
  {
    "label": "GMT+2 - Europe/Sofia - Sofia, Plovdiv, Varna, Burgas, Stara Zagora",
    "value": "Europe/Sofia"
  },
  {
    "label": "GMT+2 - Europe/Tallinn - Tallinn, Tartu, Narva, Pärnu, Nõmme",
    "value": "Europe/Tallinn"
  },
  {
    "label": "GMT+2 - Europe/Vilnius - Vilnius, Kaunas, Klaipėda, Šiauliai, Panevėžys",
    "value": "Europe/Vilnius"
  },
  {
    "label": "GMT+3 - Africa/Addis_Ababa - Addis Ababa, Jijiga, Gonder, Mek'ele, Nazrēt",
    "value": "Africa/Addis_Ababa"
  },
  {
    "label": "GMT+3 - Africa/Asmara - Asmara, Keren, Himora, Massawa, Assab",
    "value": "Africa/Asmara"
  },
  {
    "label": "GMT+3 - Africa/Dar_es_Salaam - Dar es Salaam, Mwanza, Arusha, Mbeya, Morogoro",
    "value": "Africa/Dar_es_Salaam"
  },
  {
    "label": "GMT+3 - Africa/Djibouti - Djibouti, Ali Sabih, Dikhil, Tadjoura, Arta",
    "value": "Africa/Djibouti"
  },
  {
    "label": "GMT+3 - Africa/Kampala - Kampala, Gulu, Lira, Mbarara, Jinja",
    "value": "Africa/Kampala"
  },
  {
    "label": "GMT+3 - Africa/Mogadishu - Mogadishu, Borama, Hargeysa, Berbera, Kismayo",
    "value": "Africa/Mogadishu"
  },
  {
    "label": "GMT+3 - Africa/Nairobi - Nairobi, Kakamega, Mombasa, Nakuru, Ruiru",
    "value": "Africa/Nairobi"
  },
  {
    "label": "GMT+3 - Antarctica/Syowa",
    "value": "Antarctica/Syowa"
  },
  {
    "label": "GMT+3 - Asia/Aden - Sanaa, Aden, Al Ḩudaydah, Taiz, Mukalla",
    "value": "Asia/Aden"
  },
  {
    "label": "GMT+3 - Asia/Amman - Amman, Zarqa, Irbid, Russeifa, Wādī as Sīr",
    "value": "Asia/Amman"
  },
  {
    "label": "GMT+3 - Asia/Baghdad - Baghdad, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul, Erbil",
    "value": "Asia/Baghdad"
  },
  {
    "label": "GMT+3 - Asia/Bahrain - Ar Rifā‘, Manama, Al Muharraq, Dār Kulayb, Madīnat Ḩamad",
    "value": "Asia/Bahrain"
  },
  {
    "label": "GMT+3 - Asia/Damascus - Aleppo, Damascus, Homs, Latakia, Ar Raqqah",
    "value": "Asia/Damascus"
  },
  {
    "label": "GMT+3 - Asia/Kuwait - Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim, Al Farwānīyah",
    "value": "Asia/Kuwait"
  },
  {
    "label": "GMT+3 - Asia/Qatar - Doha, Ar Rayyān, Umm Şalāl Muḩammad, Al Wakrah, Al Khawr",
    "value": "Asia/Qatar"
  },
  {
    "label": "GMT+3 - Asia/Riyadh - Jeddah, Riyadh, Mecca, Medina, Dammam",
    "value": "Asia/Riyadh"
  },
  {
    "label": "GMT+3 - Europe/Istanbul - Istanbul, Ankara, Bursa, İzmir, Gaziantep",
    "value": "Europe/Istanbul"
  },
  {
    "label": "GMT+3 - Europe/Kirov - Kirov, Kirovo-Chepetsk, Vyatskiye Polyany, Slobodskoy, Kotel’nich",
    "value": "Europe/Kirov"
  },
  {
    "label": "GMT+3 - Europe/Minsk - Minsk, Homyel', Hrodna, Mahilyow, Brest",
    "value": "Europe/Minsk"
  },
  {
    "label": "GMT+3 - Europe/Moscow - Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan, Rostov-na-Donu",
    "value": "Europe/Moscow"
  },
  {
    "label": "GMT+3 - Europe/Simferopol - Sevastopol, Simferopol, Kerch, Yevpatoriya, Yalta",
    "value": "Europe/Simferopol"
  },
  {
    "label": "GMT+3 - Europe/Volgograd - Volgograd, Volzhsky, Kamyshin, Mikhaylovka, Uryupinsk",
    "value": "Europe/Volgograd"
  },
  {
    "label": "GMT+3 - Indian/Antananarivo - Antananarivo, Toamasina, Antsirabe, Mahajanga, Fianarantsoa",
    "value": "Indian/Antananarivo"
  },
  {
    "label": "GMT+3 - Indian/Comoro - Moroni, Moutsamoudou, Fomboni, Tsimbeo, Domoni",
    "value": "Indian/Comoro"
  },
  {
    "label": "GMT+3 - Indian/Mayotte - Mamoudzou, Koungou, Dzaoudzi, Dembeni, Sada",
    "value": "Indian/Mayotte"
  },
  {
    "label": "GMT+3:30 - Asia/Tehran - Tehran, Mashhad, Isfahan, Karaj, Tabriz",
    "value": "Asia/Tehran"
  },
  {
    "label": "GMT+4 - Asia/Baku - Baku, Sumqayıt, Ganja, Lankaran, Tovuz",
    "value": "Asia/Baku"
  },
  {
    "label": "GMT+4 - Asia/Dubai - Dubai, Abu Dhabi, Sharjah, Al Ain City, Ajman City",
    "value": "Asia/Dubai"
  },
  {
    "label": "GMT+4 - Asia/Muscat - Muscat, Seeb, Bawshar, ‘Ibrī, Şalālah",
    "value": "Asia/Muscat"
  },
  {
    "label": "GMT+4 - Asia/Tbilisi - Tbilisi, Batumi, Kutaisi, Rustavi, Sokhumi",
    "value": "Asia/Tbilisi"
  },
  {
    "label": "GMT+4 - Asia/Yerevan - Yerevan, Gyumri, Vanadzor, Vagharshapat, Hrazdan",
    "value": "Asia/Yerevan"
  },
  {
    "label": "GMT+4 - Europe/Astrakhan - Astrakhan, Akhtubinsk, Znamensk, Kharabali, Kamyzyak",
    "value": "Europe/Astrakhan"
  },
  {
    "label": "GMT+4 - Europe/Samara - Samara, Tolyatti, Izhevsk, Syzran, Novokuybyshevsk",
    "value": "Europe/Samara"
  },
  {
    "label": "GMT+4 - Europe/Saratov - Saratov, Balakovo, Engels, Balashov, Vol’sk",
    "value": "Europe/Saratov"
  },
  {
    "label": "GMT+4 - Europe/Ulyanovsk - Ulyanovsk, Dimitrovgrad, Inza, Barysh, Novoul’yanovsk",
    "value": "Europe/Ulyanovsk"
  },
  {
    "label": "GMT+4 - Indian/Mahe - Victoria, Anse Boileau, Bel Ombre, Beau Vallon, Cascade",
    "value": "Indian/Mahe"
  },
  {
    "label": "GMT+4 - Indian/Mauritius - Port Louis, Vacoas, Beau Bassin-Rose Hill, Curepipe, Quatre Bornes",
    "value": "Indian/Mauritius"
  },
  {
    "label": "GMT+4 - Indian/Reunion - Saint-Denis, Saint-Paul, Le Tampon, Saint-Pierre, Saint-André",
    "value": "Indian/Reunion"
  },
  {
    "label": "GMT+4:30 - Asia/Kabul - Kabul, Herāt, Mazār-e Sharīf, Kandahār, Jalālābād",
    "value": "Asia/Kabul"
  },
  {
    "label": "GMT+5 - Antarctica/Mawson",
    "value": "Antarctica/Mawson"
  },
  {
    "label": "GMT+5 - Asia/Aqtau - Shevchenko, Zhanaozen, Beyneu, Shetpe, Kuryk",
    "value": "Asia/Aqtau"
  },
  {
    "label": "GMT+5 - Asia/Aqtobe - Aktobe, Kandyagash, Shalqar, Khromtau, Embi",
    "value": "Asia/Aqtobe"
  },
  {
    "label": "GMT+5 - Asia/Ashgabat - Ashgabat, Türkmenabat, Daşoguz, Mary, Balkanabat",
    "value": "Asia/Ashgabat"
  },
  {
    "label": "GMT+5 - Asia/Atyrau - Atyrau, Qulsary, Shalkar, Balykshi, Maqat",
    "value": "Asia/Atyrau"
  },
  {
    "label": "GMT+5 - Asia/Dushanbe - Dushanbe, Isfara, Istaravshan, Kŭlob, Konibodom",
    "value": "Asia/Dushanbe"
  },
  {
    "label": "GMT+5 - Asia/Karachi - Karachi, Lahore, Faisalabad, Rawalpindi, Multan",
    "value": "Asia/Karachi"
  },
  {
    "label": "GMT+5 - Asia/Oral - Oral, Aqsay, Zhanibek, Tasqala, Zhumysker",
    "value": "Asia/Oral"
  },
  {
    "label": "GMT+5 - Asia/Qyzylorda - Kyzylorda, Novokazalinsk, Aral, Shiyeli, Zhangaqorghan",
    "value": "Asia/Qyzylorda"
  },
  {
    "label": "GMT+5 - Asia/Samarkand - Samarkand, Nukus, Bukhara, Qarshi, Tirmiz",
    "value": "Asia/Samarkand"
  },
  {
    "label": "GMT+5 - Asia/Tashkent - Tashkent, Namangan, Andijon, Fergana, Qo‘qon",
    "value": "Asia/Tashkent"
  },
  {
    "label": "GMT+5 - Asia/Yekaterinburg - Yekaterinburg, Chelyabinsk, Ufa, Perm, Tyumen",
    "value": "Asia/Yekaterinburg"
  },
  {
    "label": "GMT+5 - Indian/Kerguelen - Port-aux-Français",
    "value": "Indian/Kerguelen"
  },
  {
    "label": "GMT+5 - Indian/Maldives - Male, Fuvahmulah, Hithadhoo, Kulhudhuffushi, Thinadhoo",
    "value": "Indian/Maldives"
  },
  {
    "label": "GMT+5:30 - Asia/Colombo - Colombo, Dehiwala-Mount Lavinia, Maharagama, Jaffna, Moratuwa",
    "value": "Asia/Colombo"
  },
  {
    "label": "GMT+5:30 - Asia/Kolkata - Mumbai, Delhi, Bengaluru, Hyderābād, Ahmedabad",
    "value": "Asia/Kolkata"
  },
  {
    "label": "GMT+5:45 - Asia/Kathmandu - Kathmandu, Bharatpur, Pātan, Birgañj, Biratnagar",
    "value": "Asia/Kathmandu"
  },
  {
    "label": "GMT+6 - Antarctica/Vostok",
    "value": "Antarctica/Vostok"
  },
  {
    "label": "GMT+6 - Asia/Almaty - Almaty, Shymkent, Karagandy, Taraz, Astana",
    "value": "Asia/Almaty"
  },
  {
    "label": "GMT+6 - Asia/Bishkek - Bishkek, Osh, Jalal-Abad, Karakol, Tokmok",
    "value": "Asia/Bishkek"
  },
  {
    "label": "GMT+6 - Asia/Dhaka - Dhaka, Chattogram, Khulna, Rangpur, Comilla",
    "value": "Asia/Dhaka"
  },
  {
    "label": "GMT+6 - Asia/Omsk - Omsk, Tara, Kalachinsk, Znamenskoye, Tavricheskoye",
    "value": "Asia/Omsk"
  },
  {
    "label": "GMT+6 - Asia/Qostanay - Kostanay, Rudnyy, Baikonur, Zhitikara, Arkalyk",
    "value": "Asia/Qostanay"
  },
  {
    "label": "GMT+6 - Asia/Thimphu - Thimphu, Phuntsholing, Tsirang, Punākha, Pemagatshel",
    "value": "Asia/Thimphu"
  },
  {
    "label": "GMT+6 - Asia/Urumqi - Ürümqi, Shihezi, Korla, Aksu, Kashgar",
    "value": "Asia/Urumqi"
  },
  {
    "label": "GMT+6 - Indian/Chagos",
    "value": "Indian/Chagos"
  },
  {
    "label": "GMT+6:30 - Asia/Yangon - Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township",
    "value": "Asia/Yangon"
  },
  {
    "label": "GMT+6:30 - Indian/Cocos - West Island",
    "value": "Indian/Cocos"
  },
  {
    "label": "GMT+7 - Antarctica/Davis",
    "value": "Antarctica/Davis"
  },
  {
    "label": "GMT+7 - Asia/Bangkok - Hanoi, Bangkok, Haiphong, Samut Prakan, Huế",
    "value": "Asia/Bangkok"
  },
  {
    "label": "GMT+7 - Asia/Barnaul - Barnaul, Biysk, Rubtsovsk, Gorno-Altaysk, Novoaltaysk",
    "value": "Asia/Barnaul"
  },
  {
    "label": "GMT+7 - Asia/Hovd - Ulaangom, Khovd, Ölgii, Altai, Uliastay",
    "value": "Asia/Hovd"
  },
  {
    "label": "GMT+7 - Asia/Ho_Chi_Minh - Ho Chi Minh City, Da Nang, Biên Hòa, Cần Thơ, Thuận An",
    "value": "Asia/Ho_Chi_Minh"
  },
  {
    "label": "GMT+7 - Asia/Jakarta - Jakarta, Surabaya, Bekasi, Bandung, Medan",
    "value": "Asia/Jakarta"
  },
  {
    "label": "GMT+7 - Asia/Krasnoyarsk - Krasnoyarsk, Abakan, Norilsk, Achinsk, Kyzyl",
    "value": "Asia/Krasnoyarsk"
  },
  {
    "label": "GMT+7 - Asia/Novokuznetsk - Kemerovo, Novokuznetsk, Prokop’yevsk, Leninsk-Kuznetsky, Kiselëvsk",
    "value": "Asia/Novokuznetsk"
  },
  {
    "label": "GMT+7 - Asia/Novosibirsk - Novosibirsk, Berdsk, Iskitim, Akademgorodok, Kuybyshev",
    "value": "Asia/Novosibirsk"
  },
  {
    "label": "GMT+7 - Asia/Phnom_Penh - Phnom Penh, Takeo, Siem Reap, Battambang, Paoy Paet",
    "value": "Asia/Phnom_Penh"
  },
  {
    "label": "GMT+7 - Asia/Pontianak - Pontianak, Palangkaraya, Singkawang, Sampit, Sungai Raya",
    "value": "Asia/Pontianak"
  },
  {
    "label": "GMT+7 - Asia/Tomsk - Tomsk, Seversk, Strezhevoy, Kolpashevo, Asino",
    "value": "Asia/Tomsk"
  },
  {
    "label": "GMT+7 - Asia/Vientiane - Vientiane, Savannakhet, Pakse, Thakhèk, Luang Prabang",
    "value": "Asia/Vientiane"
  },
  {
    "label": "GMT+7 - Indian/Christmas - Flying Fish Cove",
    "value": "Indian/Christmas"
  },
  {
    "label": "GMT+8 - Asia/Brunei - Bandar Seri Begawan, Kuala Belait, Seria, Tutong, Bangar",
    "value": "Asia/Brunei"
  },
  {
    "label": "GMT+8 - Asia/Choibalsan - Baruun-Urt, Choibalsan",
    "value": "Asia/Choibalsan"
  },
  {
    "label": "GMT+8 - Asia/Hong_Kong - Hong Kong, Kowloon, Victoria, Tuen Mun, Sha Tin",
    "value": "Asia/Hong_Kong"
  },
  {
    "label": "GMT+8 - Asia/Irkutsk - Irkutsk, Ulan-Ude, Bratsk, Angarsk, Ust’-Ilimsk",
    "value": "Asia/Irkutsk"
  },
  {
    "label": "GMT+8 - Asia/Kuala_Lumpur - Kuala Lumpur, Petaling Jaya, Klang, Johor Bahru, Ipoh",
    "value": "Asia/Kuala_Lumpur"
  },
  {
    "label": "GMT+8 - Asia/Kuching - Kota Kinabalu, Sandakan, Kuching, Tawau, Miri",
    "value": "Asia/Kuching"
  },
  {
    "label": "GMT+8 - Asia/Macau - Macau, Taipa",
    "value": "Asia/Macau"
  },
  {
    "label": "GMT+8 - Asia/Makassar - Makassar, Samarinda, Denpasar, Balikpapan, Banjarmasin",
    "value": "Asia/Makassar"
  },
  {
    "label": "GMT+8 - Asia/Manila - Quezon City, Davao, Manila, Caloocan City, Budta",
    "value": "Asia/Manila"
  },
  {
    "label": "GMT+8 - Asia/Shanghai - Shanghai, Beijing, Shenzhen, Guangzhou, Chengdu",
    "value": "Asia/Shanghai"
  },
  {
    "label": "GMT+8 - Asia/Singapore - Singapore, Jurong Town, Woodlands, Punggol, Kampong Pasir Ris",
    "value": "Asia/Singapore"
  },
  {
    "label": "GMT+8 - Asia/Taipei - Taipei, Kaohsiung, Taichung, Tainan, Banqiao",
    "value": "Asia/Taipei"
  },
  {
    "label": "GMT+8 - Asia/Ulaanbaatar - Ulan Bator, Erdenet, Darhan, Mörön, Bayanhongor",
    "value": "Asia/Ulaanbaatar"
  },
  {
    "label": "GMT+8 - Australia/Perth - Perth, Mandurah, Bunbury, Baldivis, Geraldton",
    "value": "Australia/Perth"
  },
  {
    "label": "GMT+8:45 - Australia/Eucla",
    "value": "Australia/Eucla"
  },
  {
    "label": "GMT+9 - Asia/Chita - Chita, Krasnokamensk, Borzya, Petrovsk-Zabaykal’skiy, Aginskoye",
    "value": "Asia/Chita"
  },
  {
    "label": "GMT+9 - Asia/Dili - Dili, Maliana, Suai, Likisá, Aileu",
    "value": "Asia/Dili"
  },
  {
    "label": "GMT+9 - Asia/Jayapura - Jayapura, Ambon, Sorong, Ternate, Manokwari",
    "value": "Asia/Jayapura"
  },
  {
    "label": "GMT+9 - Asia/Khandyga",
    "value": "Asia/Khandyga"
  },
  {
    "label": "GMT+9 - Asia/Pyongyang - Pyongyang, Hamhŭng, Namp’o, Sunch’ŏn, Hŭngnam",
    "value": "Asia/Pyongyang"
  },
  {
    "label": "GMT+9 - Asia/Seoul - Seoul, Busan, Incheon, Daegu, Gwangju",
    "value": "Asia/Seoul"
  },
  {
    "label": "GMT+9 - Asia/Tokyo - Tokyo, Yokohama, Osaka, Nagoya, Sapporo",
    "value": "Asia/Tokyo"
  },
  {
    "label": "GMT+9 - Asia/Yakutsk - Yakutsk, Blagoveshchensk, Belogorsk, Neryungri, Svobodnyy",
    "value": "Asia/Yakutsk"
  },
  {
    "label": "GMT+9 - Pacific/Palau - Koror, Koror Town, Kloulklubed, Ulimang, Mengellang",
    "value": "Pacific/Palau"
  },
  {
    "label": "GMT+9:30 - Australia/Adelaide - Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler",
    "value": "Australia/Adelaide"
  },
  {
    "label": "GMT+9:30 - Australia/Broken_Hill - Broken Hill",
    "value": "Australia/Broken_Hill"
  },
  {
    "label": "GMT+9:30 - Australia/Darwin - Darwin, Alice Springs, Palmerston, Howard Springs",
    "value": "Australia/Darwin"
  },
  {
    "label": "GMT+10 - Antarctica/DumontDUrville",
    "value": "Antarctica/DumontDUrville"
  },
  {
    "label": "GMT+10 - Antarctica/Macquarie",
    "value": "Antarctica/Macquarie"
  },
  {
    "label": "GMT+10 - Asia/Ust-Nera",
    "value": "Asia/Ust-Nera"
  },
  {
    "label": "GMT+10 - Asia/Vladivostok - Khabarovsk, Vladivostok, Khabarovsk Vtoroy, Komsomolsk-on-Amur, Ussuriysk",
    "value": "Asia/Vladivostok"
  },
  {
    "label": "GMT+10 - Australia/Brisbane - Brisbane, Gold Coast, Logan City, Townsville, Cairns",
    "value": "Australia/Brisbane"
  },
  {
    "label": "GMT+10 - Australia/Hobart - Hobart, Launceston, Burnie, Devonport, Sandy Bay",
    "value": "Australia/Hobart"
  },
  {
    "label": "GMT+10 - Australia/Lindeman",
    "value": "Australia/Lindeman"
  },
  {
    "label": "GMT+10 - Australia/Melbourne - Melbourne, Geelong, Ballarat, Bendigo, Point Cook",
    "value": "Australia/Melbourne"
  },
  {
    "label": "GMT+10 - Australia/Sydney - Sydney, Canberra, Newcastle, Wollongong, Maitland",
    "value": "Australia/Sydney"
  },
  {
    "label": "GMT+10 - Pacific/Chuuk - Weno, Colonia",
    "value": "Pacific/Chuuk"
  },
  {
    "label": "GMT+10 - Pacific/Guam - Dededo Village, Yigo Village, Tamuning, Tamuning-Tumon-Harmon Village, Mangilao Village",
    "value": "Pacific/Guam"
  },
  {
    "label": "GMT+10 - Pacific/Port_Moresby - Port Moresby, Lae, Mount Hagen, Popondetta, Madang",
    "value": "Pacific/Port_Moresby"
  },
  {
    "label": "GMT+10 - Pacific/Saipan - Saipan, San Jose Village",
    "value": "Pacific/Saipan"
  },
  {
    "label": "GMT+10:30 - Australia/Lord_Howe",
    "value": "Australia/Lord_Howe"
  },
  {
    "label": "GMT+11 - Antarctica/Casey",
    "value": "Antarctica/Casey"
  },
  {
    "label": "GMT+11 - Asia/Magadan - Magadan, Ust-Nera, Susuman, Ola",
    "value": "Asia/Magadan"
  },
  {
    "label": "GMT+11 - Asia/Sakhalin - Yuzhno-Sakhalinsk, Korsakov, Kholmsk, Okha, Nevel’sk",
    "value": "Asia/Sakhalin"
  },
  {
    "label": "GMT+11 - Asia/Srednekolymsk",
    "value": "Asia/Srednekolymsk"
  },
  {
    "label": "GMT+11 - Pacific/Bougainville - Arawa, Buka",
    "value": "Pacific/Bougainville"
  },
  {
    "label": "GMT+11 - Pacific/Efate - Port-Vila, Luganville, Isangel, Sola, Lakatoro",
    "value": "Pacific/Efate"
  },
  {
    "label": "GMT+11 - Pacific/Guadalcanal - Honiara, Malango, Auki, Gizo, Kirakira",
    "value": "Pacific/Guadalcanal"
  },
  {
    "label": "GMT+11 - Pacific/Kosrae - Tofol",
    "value": "Pacific/Kosrae"
  },
  {
    "label": "GMT+11 - Pacific/Norfolk - Kingston",
    "value": "Pacific/Norfolk"
  },
  {
    "label": "GMT+11 - Pacific/Noumea - Nouméa, Mont-Dore, Dumbéa, Païta, Wé",
    "value": "Pacific/Noumea"
  },
  {
    "label": "GMT+11 - Pacific/Pohnpei - Kolonia, Kolonia Town, Palikir - National Government Center",
    "value": "Pacific/Pohnpei"
  },
  {
    "label": "GMT+12 - Antarctica/McMurdo",
    "value": "Antarctica/McMurdo"
  },
  {
    "label": "GMT+12 - Asia/Anadyr - Anadyr, Bilibino",
    "value": "Asia/Anadyr"
  },
  {
    "label": "GMT+12 - Asia/Kamchatka - Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Klyuchi, Mil’kovo",
    "value": "Asia/Kamchatka"
  },
  {
    "label": "GMT+12 - Pacific/Auckland - Auckland, Wellington, Christchurch, Manukau City, North Shore",
    "value": "Pacific/Auckland"
  },
  {
    "label": "GMT+12 - Pacific/Fiji - Nasinu, Suva, Lautoka, Nadi, Labasa",
    "value": "Pacific/Fiji"
  },
  {
    "label": "GMT+12 - Pacific/Funafuti - Funafuti, Savave Village, Tanrake Village, Toga Village, Asau Village",
    "value": "Pacific/Funafuti"
  },
  {
    "label": "GMT+12 - Pacific/Kwajalein - Ebaye, Jabat",
    "value": "Pacific/Kwajalein"
  },
  {
    "label": "GMT+12 - Pacific/Majuro - Majuro, Arno, Jabor, Wotje, Mili",
    "value": "Pacific/Majuro"
  },
  {
    "label": "GMT+12 - Pacific/Nauru - Yaren, Baiti, Anabar, Uaboe, Ijuw",
    "value": "Pacific/Nauru"
  },
  {
    "label": "GMT+12 - Pacific/Tarawa - Tarawa, Betio Village, Bikenibeu Village",
    "value": "Pacific/Tarawa"
  },
  {
    "label": "GMT+12 - Pacific/Wake",
    "value": "Pacific/Wake"
  },
  {
    "label": "GMT+12 - Pacific/Wallis - Mata-Utu, Leava, Alo",
    "value": "Pacific/Wallis"
  },
  {
    "label": "GMT+12:45 - Pacific/Chatham - Waitangi",
    "value": "Pacific/Chatham"
  },
  {
    "label": "GMT+13 - Pacific/Apia - Apia, Asau, Mulifanua, Afega, Leulumoega",
    "value": "Pacific/Apia"
  },
  {
    "label": "GMT+13 - Pacific/Fakaofo - Atafu Village, Nukunonu, Fale old settlement",
    "value": "Pacific/Fakaofo"
  },
  {
    "label": "GMT+13 - Pacific/Kanton",
    "value": "Pacific/Kanton"
  },
  {
    "label": "GMT+13 - Pacific/Tongatapu - Nuku‘alofa, Lapaha, Neiafu, Pangai, ‘Ohonua",
    "value": "Pacific/Tongatapu"
  },
  {
    "label": "GMT+14 - Pacific/Kiritimati",
    "value": "Pacific/Kiritimati"
  }
]
